import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default class Errors extends React.Component {

    render() {

        const errors = Object.keys(this.props.errors).map((key) => <div key={key}>{this.props.errors[key]}</div>);

        return (
            <div className="amt-errors">
                <div className="errors-close" onClick={this.props.clearErrors}><FontAwesomeIcon icon="times"/></div>
                <div className="amt-errors-list">
                    {errors}
                </div>
            </div>
        );
    }
}